import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const CreditCardTransactionTableFilter = (props) => {
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getCurrencies();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.firmId) {
        conditions.push(`firmId eq ${values.firmId}`);
      }

      if (values.currencyId) {
        conditions.push(`currencyCode eq '${values.currencyId}'`);
      }

      const amountQuery = odata.ConditionalRange(
        "amount",
        values.amountMin,
        values.amountMax
      );
      if (amountQuery) conditions.push(amountQuery);

      if (values.transactionDateRange) {
        const [startDate, endDate] = values.transactionDateRange;

        conditions.push(odata.dateRange("transactionDate", startDate, endDate));
      }

      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }

      if (values.authCode) {
        conditions.push(odata.contains("authCode", values.authCode));
      }

      if (values.cardNumber) {
        conditions.push(odata.contains("cardNumber", values.cardNumber));
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="firmId" label="Cari :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSearch}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ text, value }) => (
                        <Select.Option key={text} value={text}>
                          {value}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item style={{ marginBottom: 0 }} label="Tutar :">
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber placeholder="Min"
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber placeholder="Max"
                              style={{ width: "100%" }}
                              precision={2}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="transactionDateRange" label="Tarih :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="cardNumber" label="Kart Numarası :">
                    <Input allowClear type="nuumber" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="authCode" label="Onay Kodu :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default CreditCardTransactionTableFilter;
